import { Checkbox, CircularProgress, withStyles } from "@material-ui/core";
import { css, cx } from "emotion";
import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import DescriptionIcon from "@material-ui/icons/Description";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import moment from "moment-timezone";
import DateRangePickerFilter from "../../components/Filters/DateRangePicker";
import CloseIcon from "@material-ui/icons/Close";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import StopIcon from "@material-ui/icons/Stop";
import HistoryItem from "./parts/HistoryItem";
import InvoiceService from "../../Services/InvoiceService";
import { chunkArray, handleError } from "../../components/Utils/Utils";
import { formatCurrency } from "../../components/Utils/Currency";
import { Skeleton } from "@material-ui/lab";
import { confirm } from "../../components/ConfirmationDialog/ConfirmationDialog";
import {Line} from "react-chartjs-2";

var idLocale = require("moment/locale/id");
moment.locale("id", idLocale);

const tableStyle = css`
  min-width: 650px !important;
  thead tr th {
    background-color: #eeeeee;
    padding: 13px 14px;
    font-size: 10px;
    font-weight: bold;
    color: #212121;
    border: none;
  }

  tbody tr {
    border-bottom: 1px solid #eeeeee;
  }

  tbody tr:hover .btn-remove {
    display: inline-block !important;
  }

  tbodt tr.group-date {
    border: none !important;
  }

  tbody tr td {
    padding: 13px 14px;
    font-size: 12px !important;
    color: #212121;
    border: none;
    vertical-align: middle;
  }
`;

const drawerWrapperStyle = css`
  position: absolute !important;
  top: -16px;
  right: -16px;
  height: calc(100vh - 64px);
  background: #ffffff;
  width: 250px !important;
  height: calc(100vh - 64px);
  overflow-y: scroll;

  @media (max-width: 576px) {
    position: fixed !important;
    width: 100vw !important;
    right: 0px !important;
    top: 56px;
    height: calc(100vh - 56px);
    height: calc(100vh - 56px);
    overflow-y: scroll;
  }
`;

const drawerStyle = css`
  width: 100% !important;
  padding: 12px !important ;
`;

const BlueCheckbox = withStyles({
  root: {
    color: "#1E88E5",
    "&$checked": {
      color: "#1E88E5",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const MutedCheckbox = withStyles({
  root: {
    color: "#E0E0E0",
    "&$checked": {
      color: "#E0E0E0",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const DisbursementChart = ({value}) => {

  const arrChunks = chunkArray(value.transaction, 7);

  const arrLabel = arrChunks[0].map((val, index) => {
      return moment(val.group_date)
        .tz(process.env.REACT_APP_TIMEZONE)
        .format("MMM D");
  });

  let max = 0;

  const arrData = arrChunks[0].map((val, index) => {
      if (val.amount > max) {
        max = val.amount;
      }

      return val.amount;
  });

  const data = (canvas) => {
    let ctx = canvas.getContext("2d");
    let gradientFill = ctx.createLinearGradient(0,0,0,300);
    gradientFill.addColorStop(0, 'rgba(58, 150, 253, 0.6)');
    gradientFill.addColorStop(0, 'rgba(58, 150, 253, 0.4)');
    gradientFill.addColorStop(1, 'rgba(255, 255, 255, 0)');

    return {
      labels: arrLabel,
      datasets: [
        {
          label: 'Transaksi',
          data: arrData,
          fill: true,
          backgroundColor: gradientFill,
          borderColor: 'rgba(58, 150, 253, 1)',
          borderWidth: 4,
          pointBackgroundColor: 'rgba(255,255,255,1)',
          pointRadius: 5,
        },
      ],
      responsive: true
    }
  }
  
  const options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            callback: function(value, index, values) {
              return value > 0 ? formatCurrency(process.env.REACT_APP_CURRENCY_CODE, (value/1000).toString()) + ` k` : value
            },
            fontSize: 10,
            color: 'rgb(151, 164, 186',
          },
          // afterBuildTicks: function(chartObj) {
          //   chartObj.ticks = [0, 100, 200, 400]
          // }
        },
      ],
    },
    legend: {
      display: false
    },
    gridLines: {
      lineWidth: 2
    },
    tooltips: {
      callbacks: {
        label: function(tooltipItem, data) {
          let label = data.datasets[tooltipItem.datasetIndex].label || '';

          if (label) {
            label += ': ';
          }

          label += formatCurrency(process.env.REACT_APP_CURRENCY_CODE, (tooltipItem.yLabel).toString());
          return label;
        }
      }
    }
  }

  return(
    <Line data={data} options={options} height={80} />
  );
}

const Disbursement = () => {
  const [open, setOpen] = React.useState(false);
  const [checkedAll, setCheckedAll] = React.useState(false);
  const [invoiceBillingSelected, setInvoiceBillingSelected] = React.useState(0);
  const [invoiceBilling, setInvoiceBilling] = React.useState({
    isLoading: false,
    data: [],
  });
  const [invoiceBillingHistory, setInvoiceBillingHistory] = React.useState({
    isLoading: false,
    data: [],
    transaction: [],
  });

  let today = moment(new Date()).format("YYYY-MM-DD") + " 23:59:59";
  let tStart = moment(new Date().setMonth(-1)).tz("UTC").format();
  let tEnd = moment(today).tz("UTC").format();
  const [dateRange, setDateRange] = React.useState({
    startDate: tStart,
    endDate: tEnd,
    key: "",
  });

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const getInvoiceBillingList = () => {
    const params = {
      progress: "wait,process,failed",
    };
    setInvoiceBilling({
      isLoading: true,
      data: [],
    });
    InvoiceService.getInvoiceBillingList(params)
      .then((response) => {
        const data = response.data.map((v) => {
          const activeInvoice = v.billing_invoices.filter((v2) => {
            return v2.progress === "wait" || v2.progress === "failed";
          });

          const detail = v.billing_invoices.map((v2) => {
            return {
              ...v2,
              checked: false,
            };
          });

          if (activeInvoice.length > 0) {
            return {
              ...v,
              billing_invoices: detail,
              disabled: false,
              checked: false,
            };
          } else {
            return {
              ...v,
              billing_invoices: detail,
              disabled: true,
              checked: false,
            };
          }
        });

        setInvoiceBilling({
          isLoading: false,
          data: data,
        });
      })
      .catch((error) => {
        setInvoiceBilling({
          isLoading: false,
          data: [],
        });
        handleError(error);
      });
  };

  function sumAmount(items) {
    return items.reduce( function(a,b) {
      return a + (b["total_amount"] - b["disbursement_fee"])
    }, 0)
  }

  const getInvoiceBillingListHistory = () => {
    const params = {
      progress: "",
      date_start: dateRange.startDate,
      date_end: dateRange.endDate,
    };
    setInvoiceBillingHistory({
      isLoading: true,
      data: [],
      transaction: [],
    });
    InvoiceService.getInvoiceBillingList(params)
      .then((response) => {
        const arrTransaction = response.data.map((val, key) => {
          return {
            group_date: val.group_date,
            amount: sumAmount(val.billing_invoices)
          }
        });

        setInvoiceBillingHistory({
          ...invoiceBillingHistory,
          isLoading: false,
          data: response.data,
          transaction: arrTransaction,
        });
      })
      .catch((error) => {
        setInvoiceBillingHistory({
          isLoading: false,
          data: [],
          transaction: []
        });
        handleError(error);
      });
  };

  function addMonths(date, months) {
    var d = date.getDate();
    date.setMonth(date.getMonth() + +months);
    if (date.getDate() !== d) {
      date.setDate(0);
    }
    return date;
  }

  const handleDateChange = (val) => {
    let startDate = moment(val.startDate).format("YYYY-MM-DD") + " 00:00:00";
    let endDate = moment(val.endDate).format("YYYY-MM-DD") + " 23:59:59";
    let maxDate =
      moment(addMonths(new Date(val.startDate), 1)).format("YYYY-MM-DD") +
      " 23:59:59";
    let tStart = moment(startDate).tz("UTC").format();
    let tEnd = moment(endDate).tz("UTC").format();

    if (new Date(endDate) <= new Date(maxDate)) {
      setDateRange({
        startDate: tStart,
        endDate: tEnd,
        key: val.key,
      });
    }
  };

  const handleCheckedAll = () => {

    const arrInvoiceBillingData = invoiceBilling?.data?.map((v) => {
      let detail = v.billing_invoices;
      let checked = v.checked;

        let selected = invoiceBillingSelected;
        detail = v.billing_invoices.map((v2) => {
          if (
            (!checkedAll === true) && (v2.progress === "wait" || v2.progress === "failed") &&
            !v2.checked
          ) {
            selected += 1;
          }

          if (
            (!checkedAll === false) && (v2.progress === "wait" || v2.progress === "failed") &&
            v2.checked
          ) {
            selected -= 1;
          }

          return {
            ...v2,
            checked: !checkedAll,
          };
        });
        checked = !checkedAll;
        setInvoiceBillingSelected(selected);

      return {
        ...v,
        checked: checked,
        billing_invoices: detail,
      };
    });
    
    setInvoiceBilling({
      ...invoiceBilling,
      data: arrInvoiceBillingData,
    });
    setCheckedAll(!checkedAll);
  };

  const handleCheckedGroup = (e) => {
    const current = JSON.parse(e.target.value);

    const arrInvoiceBillingData = invoiceBilling?.data?.map((v) => {
      let detail = v.billing_invoices;
      let checked = v.checked;

      if (v.group_date === current.group_date) {
        let selected = invoiceBillingSelected;
        detail = v.billing_invoices.map((v2) => {
          if (
            e.target.checked &&
            (v2.progress === "wait" || v2.progress === "failed") &&
            !v2.checked
          ) {
            selected += 1;
          }

          if (
            !e.target.checked &&
            (v2.progress === "wait" || v2.progress === "failed") &&
            v2.checked
          ) {
            selected -= 1;
          }

          return {
            ...v2,
            checked: e.target.checked,
          };
        });
        checked = e.target.checked;
        setInvoiceBillingSelected(selected);

        if (e.target.checked === false) {
          setCheckedAll(false)
        }
      }

      return {
        ...v,
        checked: checked,
        billing_invoices: detail,
      };
    });
    setInvoiceBilling({
      ...invoiceBilling,
      data: arrInvoiceBillingData,
    });
  };

  const handleCheckedItem = (e) => {
    const current = JSON.parse(e.target.value);

    const arrInvoiceBillingData = invoiceBilling?.data?.map((v) => {
      let checked = v.checked;
      let detail = v.billing_invoices;

      detail = v.billing_invoices.map((v2) => {
        if (current.id === v2.id) {
          if (!e.target.checked) {
            checked = false;
          }

          if (
            e.target.checked &&
            (v2.progress === "wait" || v2.progress === "failed")
          ) {
            setInvoiceBillingSelected(invoiceBillingSelected + 1);
          }

          if (
            !e.target.checked &&
            (v2.progress === "wait" || v2.progress === "failed")
          ) {
            setInvoiceBillingSelected(invoiceBillingSelected - 1);
          }

          return {
            ...v2,
            checked: e.target.checked,
          };
        } else {
          return {
            ...v2,
          };
        }
      });

      return {
        ...v,
        checked: checked,
        billing_invoices: detail,
      };
    });
    setInvoiceBilling({
      ...invoiceBilling,
      data: arrInvoiceBillingData,
    });

    if (e.target.checked === false) {
      setCheckedAll(false)
    }
  };

  const createBatchDisbursement = (params) => {
    setInvoiceBilling({
      ...invoiceBilling,
      isLoading: true,
    });
    InvoiceService.createBatchDisbursement(params)
      .then((response) => {
        setInvoiceBilling({
          ...invoiceBilling,
          isLoading: false,
        });
        getInvoiceBillingList();
      })
      .catch((error) => {
        setInvoiceBilling({
          ...invoiceBilling,
          isLoading: false,
        });
        handleError(error);
      });
  };

  const handleCreateBatchDisbursement = () => {
    let disbursement = {
      reference: "",
      disbursements: [],
    };

    let disbursements = [];

    invoiceBilling.data.map((row) => {
      return row.billing_invoices.map((row2) => {
        if (
          row2.checked &&
          (row2.progress === "wait" || row2.progress === "failed")
        ) {
          return disbursements.push({
            external_id: row2.billing_id,
            amount: row2.total_amount - row2.disbursement_fee,
            bank_code: row2.bank_account.bank_code,
            bank_account_name: row2.bank_account.bank_account_name,
            bank_account_number: row2.bank_account.bank_account_number,
            email_to: row2.tenant.email !== "" ? [row2.tenant.email] : [],
          });
        }
      });
    });
    disbursement.disbursements = disbursements;

    // CreateBatchDisbursement
    createBatchDisbursement(disbursement);
  };

  const handleDeleteBillingInvoice = (item) => {
    confirm(
      ``,
      `Are You Sure Remove Disbursement Item  (${item.billing_id})?`
    ).then(async (onProgress) => {
      setInvoiceBilling({
        ...invoiceBilling,
        isLoading: true,
      });
      InvoiceService.deleteBillingInvoice(item.id)
        .then((response) => {
          setInvoiceBilling({
            ...invoiceBilling,
            isLoading: false,
          });
          getInvoiceBillingList();
        })
        .catch((error) => {
          handleError(error);
          setInvoiceBilling({
            ...invoiceBilling,
            isLoading: false,
          });
        });
    });
  };

  React.useEffect(() => {
    getInvoiceBillingList();
  }, []);

  React.useEffect(() => {
    getInvoiceBillingListHistory();
  }, [dateRange]);

  return (
    <BaseLayout background="gray">
      <div className="row mx-0 w-100 position-relative">
        <div className="col-12 px-0 mb-0">
          <div className="row mx-0">
            <div className="col-12 px-0 mb-3">
              <div
                className={cx(
                  css`
                    border: none !important;
                    border-radius: 8px !important;
                  `,
                  "card card-body"
                )}
              >
                <div className="d-flex justify-content-end align-items-center">
                  <h3 className="font-bold font-16 text-primary mr-auto">
                    Disbursement
                  </h3>
                  <span className={css`border: 1px solid #3794FC; background-color: #3794FC; width: 10px; height: 10px; border-radius: 50%`}></span>
                  <span
                    className={cx(
                      css`
                        color: #67758d !important;
                      `,
                      "font-11 ml-1 mr-2"
                    )}
                  >
                    Transaksi
                  </span>
                  <button
                    type="button"
                    className="btn bg-white text-primary border-0 font-8 font-bold"
                    onClick={() => toggleDrawer()}
                  >
                    <DescriptionIcon className="mr-2" />
                    <span className="align-middle">History</span>
                  </button>
                </div>
                {invoiceBillingHistory?.transaction?.length > 0 && (
                  <div className="d-block">
                    <DisbursementChart value={invoiceBillingHistory} />
                  </div>
                )}
                {invoiceBillingHistory?.isLoading &&
                  invoiceBillingHistory?.transaction?.length === 0 && (
                    <div className="d-flex justify-content-center align-items-center p-5">
                      <span className="font-12 text-muted text-center font-bold">
                        <CircularProgress
                          size="1rem"
                          className={css`
                            margin-right: 10px;
                          `}
                        />
                        Loading Data ...
                      </span>
                    </div>
                  )}
                {!invoiceBillingHistory?.isLoading &&
                  invoiceBillingHistory?.transaction?.length === 0 && (
                    <div className="d-flex justify-content-center align-items-center p-5">
                      <span className="font-12 text-muted text-center font-bold">
                        No Transaction Data
                      </span>
                    </div>
                  )}
              </div>
            </div>
            <div className="col-12 px-0">
              <div
                className={cx(
                  css`
                    border: none !important;
                    border-radius: 8px !important;
                  `,
                  "card card-body"
                )}
              >
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <h3 className="font-bold font-16 text-primary mb-0">
                    Transaksi
                  </h3>
                  <button 
                  type="button" 
                  className={checkedAll ? cx(css`padding: 11px 14px !important;`,"btn rounded-8px border-1-secondary bg-blue text-white font-8 font-bold mx-2") : cx(css`padding: 11px 14px !important;`,"btn rounded-8px border-1-secondary bg-white text-primary font-8 font-bold mx-2")} 
                  onClick={handleCheckedAll}>
                    Checklist all
                  </button>
                  {invoiceBillingSelected > 0 && (
                    <button
                      type="button"
                      className="btn bg-blue text-white rounded-8px px-3 font-8 ml-auto"
                      onClick={handleCreateBatchDisbursement}
                      disabled={invoiceBilling?.isLoading}
                    >
                      SEND TO XENDIT
                    </button>
                  )}
                </div>
                <div className="table-responsive">
                  <table className={cx(tableStyle, "table table-custom-1")}>
                    <thead>
                      <tr>
                        <th width="5%"></th>
                        <th width="15%">Nama Tenant</th>
                        <th width="15%">Nama Mall</th>
                        <th width="15%">Nama Bank</th>
                        <th width="20%">Nomor Rekening</th>
                        <th width="30%">Jumlah</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!invoiceBilling?.isLoading &&
                        invoiceBilling?.data?.length > 0 &&
                        invoiceBilling?.data?.map((row) => {
                          return (
                            <React.Fragment key={row.group_date}>
                              <tr className="group-date" key={row.group_date}>
                                <td width="5%">
                                  {!row.disabled && (
                                    <BlueCheckbox
                                      icon={<RadioButtonUncheckedIcon />}
                                      checkedIcon={<CheckCircleIcon />}
                                      checked={row.checked}
                                      value={JSON.stringify(row)}
                                      onChange={(e) => handleCheckedGroup(e)}
                                    />
                                  )}

                                  {row.disabled && (
                                    <MutedCheckbox
                                      icon={<FiberManualRecordIcon />}
                                      disabled={true}
                                    />
                                  )}
                                </td>
                                <td
                                  width="95%"
                                  colSpan="5"
                                  className="font-10 font-bold"
                                >
                                  {moment(row.group_date)
                                    .tz(process.env.REACT_APP_TIMEZONE)
                                    .format("dddd, DD MMMM YYYY")}
                                </td>
                              </tr>
                              {row.billing_invoices.map((row_detail) => {
                                return (
                                  <tr key={row_detail.id}>
                                    <td width="5%">
                                      {(row_detail.progress === "wait" ||
                                        row_detail.progress === "failed") && (
                                        <BlueCheckbox
                                          checked={row_detail.checked}
                                          value={JSON.stringify(row_detail)}
                                          onChange={(e) => handleCheckedItem(e)}
                                        />
                                      )}

                                      {row_detail.progress !== "wait" &&
                                        row_detail.progress !== "failed" && (
                                          <MutedCheckbox
                                            icon={<StopIcon />}
                                            disabled={true}
                                          />
                                        )}
                                    </td>
                                    <td width="15%">
                                      {row_detail.tenant.name}
                                    </td>
                                    <td width="15%">
                                      {row_detail.tenant.property.name}
                                    </td>
                                    <td width="15%">
                                      {row_detail.bank_account.bank_name}
                                    </td>
                                    <td width="20%">
                                      {
                                        row_detail.bank_account
                                          .bank_account_number
                                      }
                                      <span className="font-10 d-block">
                                        {
                                          row_detail.bank_account
                                            .bank_account_name
                                        }
                                      </span>
                                    </td>
                                    <td
                                      width="30%"
                                      className="position-relative"
                                    >
                                      <div className="d-flex justify-content-end align-items-center">
                                        <span
                                          className={cx(
                                            css`
                                              color: #2196f3 !important;
                                            `,
                                            "font-12 font-bold mr-auto"
                                          )}
                                        >
                                          {formatCurrency(
                                            row_detail.tenant.property
                                              .currency ||
                                              process.env
                                                .REACT_APP_CURRENCY_CODE,
                                            (
                                              row_detail.total_amount -
                                              row_detail.disbursement_fee
                                            ).toString()
                                          )}
                                        </span>
                                        {row_detail.progress === "wait" && (
                                          <span className="font-8 text-blue">
                                            Waiting
                                          </span>
                                        )}
                                        {row_detail.progress === "process" && (
                                          <span className="font-8 text-warning">
                                            Send to Xendit
                                          </span>
                                        )}
                                        {row_detail.progress === "complete" && (
                                          <span className="font-8 text-green">
                                            Success
                                          </span>
                                        )}
                                        {row_detail.progress === "failed" && (
                                          <span className="font-8 text-danger">
                                            Failed
                                          </span>
                                        )}
                                      </div>
                                      {row_detail.progress === "failed" && (
                                        <button
                                          type="button"
                                          className={cx(
                                            css`
                                              position: absolute !important;
                                              right: 0 !important;
                                              top: 0 !important;
                                              height: 100% !important;
                                              border-radius: 0px !important;
                                              padding: 12px 16px !important;
                                              display: none !important;
                                            `,
                                            "btn btn-danger btn-remove"
                                          )}
                                          onClick={() =>
                                            handleDeleteBillingInvoice(
                                              row_detail
                                            )
                                          }
                                        >
                                          Remove
                                        </button>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </React.Fragment>
                          );
                        })}

                      {/* Loading */}
                      {invoiceBilling?.isLoading &&
                        Array.from(new Array(3)).map((row, key) => {
                          return (
                            <React.Fragment key={key}>
                              <tr className="group-date">
                                <td width="5%">
                                  <Skeleton
                                    variant="circle"
                                    animation="wave"
                                    width={24}
                                    height={24}
                                  />
                                </td>
                                <td
                                  width="95%"
                                  colSpan="5"
                                  className="font-10 font-bold"
                                >
                                  <Skeleton
                                    variant="text"
                                    animation="wave"
                                    width={200}
                                  />
                                </td>
                              </tr>
                              {Array.from(new Array(3)).map((row2, key2) => {
                                return (
                                  <tr key={key2}>
                                    <td width="5%">
                                      <Skeleton
                                        variant="rect"
                                        animation="wave"
                                        width={24}
                                        height={24}
                                      />
                                    </td>
                                    <td width="15%">
                                      <Skeleton
                                        variant="text"
                                        animation="wave"
                                      />
                                    </td>
                                    <td width="15%">
                                      <Skeleton
                                        variant="text"
                                        animation="wave"
                                      />
                                    </td>
                                    <td width="15%">
                                      <Skeleton
                                        variant="text"
                                        animation="wave"
                                      />
                                    </td>
                                    <td width="20%">
                                      <p>
                                        <Skeleton
                                          variant="text"
                                          animation="wave"
                                        />
                                        <Skeleton
                                          variant="text"
                                          animation="wave"
                                        />
                                      </p>
                                    </td>
                                    <td width="30%">
                                      <div className="d-flex justify-content-between align-items-center">
                                        <Skeleton
                                          variant="text"
                                          animation="wave"
                                          width={150}
                                        />
                                        <Skeleton
                                          variant="text"
                                          animation="wave"
                                          width={80}
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </React.Fragment>
                          );
                        })}

                      {!invoiceBilling?.isLoading &&
                        invoiceBilling.data.length === 0 && (
                          <tr>
                            <td
                              colSpan="6"
                              className="font-12 text-muted text-center font-bold"
                            >
                              No Invoice Data
                              <br />
                              <small>
                                All invoices have been paid successfully
                              </small>
                            </td>
                          </tr>
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={open ? cx("col px-0", drawerWrapperStyle) : "d-none"}>
          <div className="w-100 d-flex justify-content-end align-items-center mb-2 p-1">
            <button
              type="button"
              className="btn btn-sm p-0"
              onClick={() => toggleDrawer()}
            >
              <CloseIcon />
            </button>
          </div>
          <div className={drawerStyle}>
            <DateRangePickerFilter
              onChange={(val) => handleDateChange(val)}
              defaultDate={dateRange}
              maxDate={new Date()}
            />
            <h4 className="font-16 font-bold text-primary my-3">History</h4>
            <hr
              className={cx(
                css`
                  display: block;
                  border: solid 1px #eeeeee;
                `,
                "mb-3"
              )}
            />
            {!invoiceBillingHistory.isLoading &&
              invoiceBillingHistory.data.length > 0 &&
              invoiceBillingHistory.data.map((val, key) => {
                return <HistoryItem key={key} data={val} />;
              })}

            {!invoiceBillingHistory.isLoading &&
              invoiceBillingHistory.data.length === 0 && (
                <p className="text-center text-muted font-bold font-12">
                  No History Data
                  <br />
                  <small>Try other date range</small>
                </p>
              )}

            {invoiceBillingHistory.isLoading &&
              Array.from(new Array(5)).map((val, key) => {
                return (
                  <div className="mb-3" key={key}>
                    <Skeleton
                      variant="rect"
                      animation="wave"
                      width="100%"
                      height={62}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default Disbursement;
